// extracted by mini-css-extract-plugin
export default {"container":"TitleHeader_container__5PzXv","backArrow":"TitleHeader_backArrow__6pSRi"};